/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Kind_PortableInputs */

const en_fc_dl_kind_portable = /** @type {(inputs: Fc_Dl_Kind_PortableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portable (zip)`)
};

/**
* | output |
* | --- |
* | "Portable (zip)" |
*
* @param {Fc_Dl_Kind_PortableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_kind_portable = /** @type {((inputs?: Fc_Dl_Kind_PortableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Kind_PortableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_kind_portable(inputs)
});
export { fc_dl_kind_portable as "fc.dl.kind.portable" }